<template>
  <div
    class="card-item options-api"
    :class="{ 'card-item-search': cardSearchable, 'smallMinWidth':smallCardDesign , mr12: marginGap, mt6: top10 }"
    v-if="result && Object.keys(result).length > 2"
    :counterTextObserver="productObserver"
    ref="productCard"
    :id="dataCounterText"
    @touchstart.stop
    @touchmove.stop
    v-memo="[
      itemQuantity,
      result.itemPrice,
      showCustmizationModal,
      showAddOrEditCheckModal,
      disbaleButtonModal,
      showRepeatOrAddCustomizationModal,
      showAddOrEditCheckModalSource,
      recommendateItem,
      cardSource,
      crossSellWithProduct,
      crossSellWithProduct.productId == result.code,
      crossSellWithProduct.categoryId == dataCategoryId,
      cardSearchable,
      showUpsell,
      showCrossell,
      dataCounterText,
      nonCustomiseModal,
    ]"
  >
    <!-- Intersection Observer :counterTextObserverForFirstCategory="productObserverForFirstCategory"-->
    <!-- <Observer v-if="dataIndex == 6" @intersect="itisvisible" /> -->
    <Observer
      :options="{ rootMargin: '-50px' }"
      @intersect="individualCardVisible"
      :custom-disconnect-flag="dataType === 'reorder' ? false : true"
    />
    <div class="pa ribbonIcon" v-if="top10 !== 'undefined' && top10 === true">
      <div class="pr">
        <div class="pa ribbonIconTitle">
          <div
            class="ribbonTitle1"
            :style="{
              color: ribbonTitleColor1,
            }"
          >
          {{ ribbonTitle1 }}
          </div>
          <div
            class="ribbonTitle2"
            :style="{
              color: ribbonTitleColor2,
            }"
          >
          {{ ribbonTitle2 }}
          </div>
        </div>
        <img class="" :src="ribbonIcon" />
      </div>
      <div></div>
    </div>
    <div
      class="card-size"
      :class="{ 'card-rounded': cardRounded , 'flex-row gap8 pd8': smallCardDesign}"
      @click.stop="triggerModal($event, 'banner')"
    >
      <div :class="{'c-img-wrap' : !smallCardDesign}">
        <template v-if="result?.images?.length > 0">
          <template v-if="!cardSearchable">
            <product-video
              v-if="isVideoCard"
              :product-id="result?.code"
              video-class="card-video video-product-home"
              placeholder-class="card-img img-product-home"
              :src="Utility.getProductVideo(result?.videos, 'HomeVideoV1')"
              type="video/mp4"
              :src-thumbnail="
                Utility.getProductImages(result?.images, 'HomeProductV1')
                "
              :src-thumbnail-placeholder="getPlaceHolderImg "
              :autoplay-in-focus="true"
              :intersection-options="{
                threshold: 1,
                rootMargin: '0px 0px -50px 0px',
                root: null,
              }"
              @video-event="videoEventFunction"
            />
            <lazy-image
              v-else
              class="card-img img-product-home"
              alt="default image"
              :src="Utility.getProductImages(result?.images, 'HomeProductV1')"
              :src-placeholder="getPlaceHolderImg"
              :intersection-options="{ rootMargin: '800px' }"
            />
          </template>
          <template v-if="cardSearchable">
            <template v-if="!SeparateMenuLoadImage">
              <div :class="{'smallCardDesign pr extSmallImgParent' : smallCardDesign}">
                <lazy-image
                class="card-img img-product-search"
                :class="{'extSmallImg': smallCardDesign}"
                alt="default image"
                :src="
                  Utility.getProductImages(result?.images, 'SearchProductV1')
                "
                :src-placeholder="getPlaceHolderImg "
                :intersection-options="{ rootMargin: '600px' }"
                />
                <i
                class="mr8 pa"
                :class="[
                  {
                    'tag-veg': isProductVeg,
                  },
                  {
                    'tag-non-veg': isProductNonveg,
                  },
                ]"
                v-if="smallCardDesign"
              ></i>
              </div>
            </template>
            <template v-if="SeparateMenuLoadImage">
              <img
                class="card-img img-product-search"
                alt="default image"
                :src="
                  Utility.getProductImages(result?.images, 'SearchProductV1')
                "
              />
            </template>
          </template>
        </template>
        <template v-else>
          <product-video
            v-if="isVideoCard"
            :product-id="result.code"
            video-class="card-video video-product-home"
            placeholder-class="card-img backup-img"
            :src="Utility.getProductVideo(result?.videos, 'HomeVideoV1')"
            type="video/mp4"
            :src-thumbnail="
              imgBaseUrl + '/' + result.image + Utility.getSitePropsVersion()
              "
            :autoplay-in-focus="true"
            :src-thumbnail-placeholder="getPlaceHolderImg"
            :intersection-options="{
              threshold: 1,
              rootMargin: '0px 0px -50px 0px',
              root: null,
            }"
            @video-event="videoEventFunction"
          />
          <div v-else :class="{'smallCardDesign pr extSmallImgParent' : smallCardDesign}">
            <lazy-image
              class="card-img backup-img"
              :class="{'extSmallImg': smallCardDesign}"
              alt="product image"
              :src="
                imgBaseUrl + '/' + result.image + Utility.getSitePropsVersion()
              "
              :src-placeholder="getPlaceHolderImg "
            />
          </div>
        </template>
      </div>

      <div class="card-content">
        <div class="at-top" v-if="!cardSearchable">
          <div
            class="tag-bg-black speciality"
            v-if="dataType === 'Recommended'"
          >
            <span class="ico-trending"><i class="jfi-trending"></i></span
            >Popular in {{ result.customCategoryName }}
          </div>
          <div
            class="selling-tag"
            v-if="
              top10 !== 'undefined' &&
              top10 === false &&
              dataType !== 'Recommended' &&
              recommendateItem
            "
          >
            {{ recommendateItem }}
          </div>
          <div 
            v-if="
              Object.keys(getBogoConfig).length &&
              bogoItemTag
            "
            class="tag-bg-white bold"
          >
            {{ bogoItemTag }}
          </div>
        </div>
        <div :class="{ 'card-botm-gradient': !cardSearchable , 'at-botm' : !smallCardDesign , 'smallCardDesign':smallCardDesign}">
          <!--           <div class="tag-bg-yellow p-disc hide" v-if="!cardSearchable">
            <div class="fs-12 bold lh18 disp-col-inline">
              <i class="jfi-offer-tag mr8"
                ><span class="ico-percent">%</span></i
              >
              20% OFF
            </div>
            <div class="fs-10 lh16 bold">
              Code: <span class="upercase">NONSTOP60</span>
            </div>
          </div> -->

          <!-- extra info -->
          <div class="extra-info">
            <!--             <div
              class="tag-bg-black rating-info ib mr8 hide"
              v-if="!cardSearchable"
            >
              <span class="bold">4.2</span>
              <i class="jfi-star ml5 mr5"></i>
              <span class="color-white">2k</span>
            </div> -->
            <!--             <div class="tag-bg-black ib" v-if="!cardSearchable">
              <span class="ico-red-holder"><i class="jfi-trending"></i></span>
              <span class="bold upercase fs-10">SPICY</span>
            </div> -->
            <!-- "customized" class will be added along "tag-customize", when card is customised -->
            <!-- :class="{'customized': !itemIsCustomized()}" -->
            <div
              v-if="result.isCustomizable || itemIsCustomisableCrustSize"
              class="tag-customize ib"
              :class="{ 
                customized: itemIsCustomized() ,
                hide : itemIsCustomisableCrustSize || (smallCardDesign && !itemIsCustomized()),
                'fr': !smallCardDesign 
              }"
              @click.stop="
                triggerModal($event, 'customiseBtn'),
                  userActivityTracking.customizeClicked(cardSearchable ? 3 : 0)
              "
            >
              <span class="ico-checkmark" v-if="!smallCardDesign"><i class="jfi-checker"></i></span>
              <span class="cust-text" :class="[smallCardDesign ? 'mr3' : 'bold mr10 ml5']"></span>
              <span class="ico-checkmark" v-if="smallCardDesign"><i class="jfi-checker"></i></span>
              <i class="jfi-arrow-line" v-if="!smallCardDesign"></i>
            </div>

            <!-- modal for customization -->
            <generic-modal
              v-if="showCustmizationModal"
              @close.stop="closeCustomizationModal($event, '')"
              :width="custModalDim.width"
              :modalClass="custModalDim.modalClass"
              :height="custModalDim.height"
              :overflowNotNeeded="0"
              :genericModalSource="'customizationModal'"
            >
              <template v-slot:header>
                <i
                  @click.stop="
                    closeCustomizationModal($event, 'cross'),
                      userActivityTracking.customizeCloseClicked(2)
                  "
                  class="jfi-close-v2 cross-holder"
                ></i>
              </template>
              <template v-slot:body>
                <div class="customization-pop-content">
                  <product-customization
                    :data-result="result"
                    @close.stop="closeCustomizationModal($event, '')"
                    @item-customised="itemIsCustomized()"
                    @scroll-cross-sell-into-view="scrollCrossSellIntoView()"
                    :last-edit="islastEditOn"
                    :new-feature="newItemRemoveFeature"
                    :data-customisePopupSource="customisePopupSource"
                    :data-type="dataType"
                    :data-add-counter="itemQuantity"
                    :data-index="dataIndex"
                    :data-isCustomised="itemIsCustomized()"
                  ></product-customization>
                </div>
              </template>
              <template v-slot:footer>
                <div></div>
              </template>
            </generic-modal>

            <!-- modal tobe shown, if quantity > 0 and then clicked on customisation btn -->
            <generic-modal
              v-if="showAddOrEditCheckModal"
              @close="closeAddOrEditCheckModal($event)"
              :height="addOrEditModalDim.height"
              :width="addOrEditModalDim.width"
              :animationStyle="addOrEditModalDim.animationStyle"
              :genericModalSource="'custBtn'"
              :sectionName="sectionName"
            >
              <template v-slot:header>
                <i
                  @click.stop="closeAddOrEditCheckModal($event, 'crossCustBtn')"
                  class="jfi-close-v2 sticky-pop-cross"
                ></i>
              </template>
              <template v-slot:body>
                <div class="ms-offer-pop-content">
                  <div class="btn-wrap mt30">
                    <button
                      class="btn medium"
                      @click.stop="
                        addANewPizza(
                          $event,
                          showAddOrEditCheckModalSource || 'custBtn'
                        )
                      "
                    >
                      Add A New Pizza
                    </button>
                  </div>
                  <div class="btn-wrap mb15">
                    <button
                      class="line-btn dark medium w100"
                      @click.stop="editLastAddedPizza($event, 'custBtn')"
                    >
                      Edit Last Added Pizza
                    </button>
                  </div>
                </div>
              </template>
              <template v-slot:footer>
                <div></div>
              </template>
            </generic-modal>

            <!-- customization disbale button modal -->
            <generic-modal
              v-if="disbaleButtonModal"
              @close="closeDisableButtonModal()"
              :height="addOrEditModalDim.height"
              :width="addOrEditModalDim.width"
              :animationStyle="addOrEditModalDim.animationStyle"
            >
              <template v-slot:header>
                <i
                  @click.stop="closeDisableButtonModal()"
                  class="jfi-cross sticky-pop-cross"
                ></i>
              </template>
              <template v-slot:body>
                <div class="ms-offer-pop-content pb20 pt20 bold fs-20">
                  You can't remove the items from here after you have
                  customized. <br /><br />
                  Please go to <a href="/cart">Cart</a> for removing already
                  customised items.
                </div>
              </template>
              <template v-slot:footer>
                <div></div>
              </template>
            </generic-modal>

            <!-- modal tobe shown, if quantity > 0 and then clicked on Add/Minus Cta btn -->
            <generic-modal
              v-if="showRepeatOrAddCustomizationModal"
              @close="closeRepeatOrAddModal($event, 'addMinusBtn')"
              :height="addOrEditModalDim.height"
              :width="addOrEditModalDim.width"
              :animationStyle="addOrEditModalDim.animationStyle"
              :genericModalSource="'addMinusBtn'"
              :sectionName="dataType"
            >
              <template v-slot:header>
                <span class="fs-18 bold color-black"
                  >Repeat last customisation?</span
                >
                <i
                  @click.stop="
                    closeRepeatOrAddModalThroughCrossTap($event, 'addMinusBtn')
                  "
                  class="jfi-close-v2 sticky-pop-cross"
                ></i>
              </template>
              <template v-slot:body>
                <div class="mt30">
                  <!-- last customosed crust and size -->
                  <div class="disp-col-inline jcsb">
                    <div class="fs-14">
                      <span>{{ result.sizeName }}</span>
                      <span class="separater-before">{{
                        result.crustName
                      }}</span>
                    </div>
                    <span class="fs-18 bold">
                      <span :class="currencyIconClass">Rs.</span
                      >{{
                        itemIsCustomized()
                          ? getTotalCustomisedPriceWithToppings
                          : result.itemPrice
                      }}
                    </span>
                  </div>
                  <!-- last customised toppings -->
                  <div class="lh18 mt5 disp-col-inline jcsb align-items-start">
                    <div>
                      <span v-if="currentToppings(result.addTopngs).length > 0"
                        >Added:
                        <span class="color-grey">{{
                          currentToppings(result.addTopngs) || ""
                        }}</span
                        >.</span
                      >
                      <span v-if="replaceTopDis().length > 0"
                        >Replaced:
                        <span
                          class="color-grey"
                          v-if="replaceTopDis().length > 0"
                          >{{ replaceTopDis() }}</span
                        >.</span
                      >
                    </div>
                    <div class="base-price ml10">
                      <span class="color-grey fs-12"
                        >Including base price
                        <span :class="currencyIconClass">Rs.</span
                        >{{ result.defaultPrice }}</span
                      >
                    </div>
                  </div>
                  <div class="btn-wrap mt25">
                    <button
                      class="btn medium w100"
                      @click.stop="
                        repeatLastCustomization($event, 'addMinusBtn')
                      "
                    >
                      Repeat Last Customisation
                    </button>
                  </div>
                  <div class="btn-wrap mb15">
                    <button
                      class="line-btn dark medium w100"
                      @click.stop="addANewPizza($event, 'addMinusBtn')"
                    >
                      Add New Customisation
                    </button>
                  </div>
                </div>
              </template>
              <template v-slot:footer>
                <div></div>
              </template>
            </generic-modal>
          </div>

          <!-- pizza title and desc -->
          <div
            class="pizza-info"
            :class="{'pizza-info2': (dataType == 'reorder' && !smallCardDesign) , 'pizza-info3': smallCardDesign }"
          >
            <h2
            :class="{ 'multi-line-ellipses-v2': (dataType == 'reorder' && !smallCardDesign) , '': smallCardDesign }"
            >
              <i
                class="mr8"
                :class="[
                  {
                    'tag-veg': isProductVeg,
                  },
                  {
                    'tag-non-veg': isProductNonveg,
                  }
                ]"
                 v-if="!smallCardDesign"
              ></i>
              <span class="pizza-title" :class="{'bold': !smallCardDesign}">{{ result.name }}</span>
            </h2>
            <h3 v-if="!smallCardDesign" class="pizza-desc lh16" v-once>{{ result.description }}.</h3>
            <h3 
              v-if="
                cardSearchable && 
                isItemBogo &&
                getBogoConfig?.searchText
              "
              class="pizza-bogo-desc mt8"
            >
              <i class="jfi-offers-v2"></i>
              <span class="ml6 fs-11 lh12">{{getBogoConfig.searchText}}</span>
            </h3>

            <!-- search-cards-only -->
            <div class="search-cards-only"  v-if="cardSearchable && !smallCardDesign">
              <!-- <div class="tag-bg-white rating-info ib">
                <span class="bold color-base">4.2</span>
                <i class="jfi-star ml5 mr5"></i>
                <span class="color-base">2k</span>
              </div>
              <div class="tag-bg-white ib ml8">
                <span class="ico-red-holder"><i class="jfi-trending"></i></span>
                <span class="bold upercase fs-10">SPICY</span>
              </div> -->
              <div
                class="tag-bg-white ib"
                :class="{ hide: !(recommendateItem.length > 0) }"
              >
                <span class="bold upercase fs-10">Bestseller</span>
              </div>
            </div>
          </div>

          <!-- pizza price and Add cta -->
          <div
            class="selected-info"
            :class="{ 'bg-grad-black': !cardSearchable }"
          >
            <div class="selections">
              <div class="pizza-price disp-col-inline" v-if="getTotalCustomisedPriceWithToppings || result.itemPrice">
                <span>
                  <i :class="currencyIconClass">Rs.</i>
                  <span>
                    {{
                      itemIsCustomized()
                        ? getTotalCustomisedPriceWithToppings
                        : result.itemPrice
                    }}
                  </span>
                </span>
                <template v-if="checkIfValidStrikePrice">
                  <span 
                    class="striked-price fs-14"
                    :class="{'color-grey': cardSearchable , 'striked-price-small-card-reorder' : smallCardDesign}"
                  >
                    <i :class="currencyIconClass">Rs.</i>
                    <span>
                      {{ mealOriginalPrice }}
                    </span>
                  </span>
                  <div class="d-flex align-items-center"  :class="[smallCardDesign ? 'saved-amount-small-card-reorder' : 'saved-amount']">
                    <span class="saved-amount-price">
                      Save 
                      <i :class="currencyIconClass">Rs.</i>{{ mealSavingPrice }}
                    </span>
                  </div>
                </template>
                <!-- for EVD case only -->
                <!--                 <div class="evd-price ml8">
                  <span class="striked-price ib mr8"
                    ><i :class="currencyIconClass">Rs.</i> 350</span
                  >
                  <div class="saving-tag bold ib">
                    Save <i :class="currencyIconClass">Rs.</i> 120
                    <span class="lft-arr">
                      <i class="jfi-arrow-line"></i>
                    </span>
                  </div>
                </div> -->
              </div>
              <div class="size-selected" v-if="result.crust &&(getTotalCustomisedPriceWithToppings || result.itemPrice) && !smallCardDesign">
                <span
                  class="selected-p-profile disp-col-inline"
                  :class="{ 'color-white': !cardSearchable }"
                >
                  <ul
                    class="disp-col-inline three-dot"
                    :class="{ 'dashed-botm ': result.isCustomizable || itemIsCustomisableCrustSize }"
                  >
                    <li
                      @click.stop="
                         (result.isCustomizable || itemIsCustomisableCrustSize) && 
                          triggerModal($event, 'crustNSize')
                      "
                    >
                      <span class="p-size" :class="{'color-slaty' : !(result.isCustomizable || itemIsCustomisableCrustSize) && cardSearchable}">
                        {{ currentSize() || result.sizeName }}
                      </span>
                      <span class="p-crust" :class="{'color-slaty' : !(result.isCustomizable || itemIsCustomisableCrustSize) && cardSearchable}">{{
                        currentCrust() || result.crustName
                      }}</span>
                    </li>
                    <!-- <li>
                        <span class="p-size"> </span>
                        <span class="p-crust">{{
                          getCrust(result.crust, result.crustId)
                        }}</span>
                      </li> -->
                  </ul>

                  <i class="jfi-arrow-line" v-if="result.isCustomizable || itemIsCustomisableCrustSize"></i>
                </span>
              </div>
            </div>
            <div class="main-cta">
              <div
                v-if="itemQuantity > 0"
                class="cta-edit"
                :class="{ dark: cardSearchable }"
              >
                <!-- <span
                  class="anim-ico-minus item-status-anim"
                  :class="{ disabled: itemIsCustomized() }"
                  @click="removeFromCart()"
                ></span> -->
                <span
                  @click.stop="
                    itemIsCustomized() && !newItemRemoveFeature
                      ? triggerDisableButtonModal()
                      : removeFromCart($event)
                  "
                  class="anim-ico-minus item-status-anim"
                  :class="{
                    'disable-with-event':
                      itemIsCustomized() && !newItemRemoveFeature,
                  }"
                >
                </span>
                <span>{{ itemQuantity }}</span>
                <span
                  class="anim-ico-plus tr item-status-anim"
                  @click.stop="addToCart($event)"
                ></span>
              </div>

              <button
                v-if="itemQuantity === 0"
                class="btn hand cta-add"
                :class="{'bold' : !smallCardDesign}"
                @click.prevent="addToCart($event)"
              >
                Add <span class="ico-plus">&#43;</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="customizations pr"
      @click.stop="() => {}"
      v-if="
        hideToppingInRecommendedItems != 'undefined' &&
        hideToppingInRecommendedItems &&
        (currentToppings(result.addTopngs).length > 0 ||
          replaceTopDis().length > 0) &&
        dataType != 'reorder' &&
        isNewEventCard != true
      "
    >
      <span
        class="color-base"
        v-if="currentToppings(result.addTopngs).length > 0"
        >Added:&nbsp;</span
      >
      <span
        class="color-grey"
        v-if="currentToppings(result.addTopngs).length > 0"
      >
        {{ currentToppings(result.addTopngs) || "" }}.
      </span>
      <span class="color-base" v-if="replaceTopDis().length > 0"
        >Replaced:&nbsp;</span
      >
      <span class="color-grey" v-if="replaceTopDis().length > 0"
        >{{ replaceTopDis() || "" }}
      </span>
      <div class="border-bottom-light-center"></div>
    </div>
    <div
      @touchstart.stop
      @touchmove.stop
      v-if="showingCrossSellOrUpSell"
      ref="upsellAndCrossSell"
    >
      <transition name="upsell-transition">
        <up-sell
          :data-item="result"
          v-if="showingUpSell"
          :updated-price = "itemIsCustomized()
                        ? getTotalCustomisedPriceWithToppings
                        : result.itemPrice"
        ></up-sell>
      </transition>
      <cross-sell
        :data-productId="result.code"
        :data-categoryId="dataCategoryId"
        :data-item="result"
        v-if="showingCrossSell"
      ></cross-sell>
    </div>

    <!-- Non customisation bottom sheet -->
    <generic-modal
      v-if="nonCustomiseModal"
      @close="closeNonCustomiseModal()"
      :height="nonCustomiseCss.height"
      :width="nonCustomiseCss.width"
      :animationStyle="nonCustomiseCss.animationStyle"
      :padding="'0px'"
      :genericModalSource="'nonCustomization'"
      :sectionName="dataType"
      class="card-item-search-non-customize-modal"
    >
      <template v-slot:header>
        <i
          @click.stop="closeNonCustomiseModal('cross')"
          class="jfi-close-v2 cross-holder"
        ></i>
      </template>
      <template v-slot:body>
        <div class="">
          <!-- <template> -->
          <div class="w100">
            <div class="card-size">
              <div class="c-img-wrap non-cusm-item">
                <template v-if="result?.images?.length > 0">
                  <template v-if="!cardSearchable">
                    <lazy-image
                      class="card-img img-product-home"
                      alt="default image"
                      :src="
                        Utility.getProductImages(
                          result?.images,
                          'HomeProductV1'
                        )
                      "
                      :src-placeholder="getPlaceHolderImg"
                      :intersection-options="{ rootMargin: '800px' }"
                    />
                  </template>
                  <template v-if="cardSearchable">
                    <lazy-image
                      class="card-img img-product-search"
                      alt="default image"
                      :src="
                        Utility.getProductImages(
                          result?.images,
                          'HomeProductV1'
                        )
                      "
                      :src-placeholder="getPlaceHolderImg"
                      :intersection-options="{ rootMargin: '600px' }"
                    />
                  </template>
                </template>
                <template v-else>
                  <lazy-image
                    class="card-img backup-img"
                    alt="product image"
                    :src="
                      imgBaseUrl +
                      '/' +
                      result.image +
                      Utility.getSitePropsVersion()
                    "
                  />
                </template>
              </div>
              <div class="card-content">
                <div class="top-grad"></div>
                <div class="at-botm card-botm-gradient">
                  <div class="pizza-info">
                    <h2>
                      <i
                        class="mr8"
                        :class="[
                          {
                            'tag-veg': isProductVeg,
                          },
                          {
                            'tag-non-veg': isProductNonveg,
                          },
                        ]"
                      ></i>
                      <span class="pizza-title bold">{{ result.name }}</span>
                    </h2>
                    <h3 class="pizza-desc lh16" v-once>
                      {{ result.description }}.
                    </h3>

                    <!-- search-cards-only -->
                    <div class="search-cards-only" v-if="cardSearchable">
                      <!-- <div class="tag-bg-white rating-info ib">
                          <span class="bold color-base">4.2</span>
                          <i class="jfi-star ml5 mr5"></i>
                          <span class="color-base">2k</span>
                        </div>
                        <div class="tag-bg-white ib ml8">
                          <span class="ico-red-holder"><i class="jfi-trending"></i></span>
                          <span class="bold upercase fs-10">SPICY</span>
                        </div> -->
                      <div
                        class="tag-bg-white ib"
                        :class="{ hide: !(recommendateItem.length > 0) }"
                      >
                        <span class="bold upercase fs-10">Bestseller</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- </template> -->
          <div
            class="w100 pt16 pb16 pl16 pr16"
            @click.prevent="nonCustomiseHandler($event)"
          >
            <button class="btn bold w100">
              <i :class="currencyIconClass">Rs.</i> {{ result.itemPrice }} | Add
              <span class="ico-plus">&#43;</span>
            </button>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal>
  </div>
</template>

<script setup>
import LazyImage from "./LazyImage.vue";
</script>

<script>
import { defineAsyncComponent } from "vue";
import GenericModal from "./GenericModal.vue";
import { imgBaseUrl, staticImgBaseUrl, videoSwitch, currencyIconClass } from "../config/apiEndpoints";
import Observer from "../assets/Observer.vue";
import {
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_VARIANT_NEXTGEN_HOMEPAGE_HEADER_NAME
} from "../config/vwoKeys";
import PageNames from "../config/pageNames";

import {
  keyMapsMutation,
  keyMapsGetter,
  keyMapsAction,
} from "../helpers/storeKeys";

import LocalStorageFunc from "../helpers/localStorageFunc";
import Utility from "../helpers/utility.js";
import setEvents from "../helpers/events";
import userActivityTracking from "../helpers/UserActivityTracking";

export default {
  name: "ProductCard",
  props: [
    "dataCardRounded",
    "dataCardSearchable",
    "dataCardSource",
    "dataResult",
    "dataModuleProps",
    "dataCounterText",
    "dataCategoryId",
    "marginGap",
    "dataType",
    "dataIndex",
    "dataShowUpsell",
    "dataShowCrossell",
    "top10",
    "ribbonIcon",
    "ribbonTitleColor1",
    "ribbonTitleColor2",
    "ribbonTitle1",
    "ribbonTitle2",
    "isNewEventCard",
    "smallCardDesign"
  ],
  emits: ["getItem"],
  components: {
    GenericModal,
    Observer,
    ProductCustomization: defineAsyncComponent(() =>
      import("./ProductCustomization.vue")
    ),
    CrossSell: defineAsyncComponent(() => import("./CrossSell.vue")),
    UpSell: defineAsyncComponent(() => import("./UpSell.vue")),
    ProductVideo: defineAsyncComponent(() => import("./ProductVideo.vue")),
  },

  data() {
    return {
      cardRounded:
        this.dataCardRounded != "null" &&
        typeof this.dataCardRounded != "undefined"
          ? this.dataCardRounded
          : false,
      cardSource: "",
      showUpsell: "",
      showCrossell: "",
      // cardSearchable: false,
      imgBaseUrl: imgBaseUrl,
      staticImgBaseUrl: staticImgBaseUrl,
      showCustmizationModal: false,
      custModalDim: {
        width: "100vw",
        height: "100%",
        modalClass: "full-screen-popup cust-modal-wrap",
      },
      productResult: {},
      showAddOrEditCheckModal: false,
      showAddOrEditCheckModalSource: "",
      addOrEditModalDim: {
        width: "100vw",
        height: "calc(91vh - 56px)",
        animationStyle: "slide-up-stick-bottom",
        modalClass: "modal-bg-blackout",
      },
      showRepeatOrAddCustomizationModal: false,
      isUserCustomizable: false,
      islastEditOn: false,
      disbaleButtonModal: false,
      newItemRemoveFeature: true, // property base feature
      customisePopupSource: "customise",
      nonCustomiseModal: false,
      nonCustomiseCss: {
        width: "100vw",
        height: "auto",
        animationStyle: "slide-up-stick-bottom",
        modalClass: "modal-bg-blackout",
      },
      isUpdated: false,
      sectionName: "",
      mealSavingPrice: 0,
      mealOriginalPrice: 0,
      mealFinalPrice: 0
    };
  },
  created() {},
  emits: ["add-to-cart", "open-customise", "open-upsell", "show-all-cards", "change-counter-text"],
  mounted() {
    this.cardSource = this.dataCardSource || "";
    this.showUpsell = this.dataShowUpsell || false;
    this.showCrossell = this.dataShowCrossell || false;
    this.$store.commit(
      keyMapsMutation.UPDATE_CART_ITEM_PRICE_ARRAY,
      LocalStorageFunc.getToppingArrayPriceKeyLocalStorage(
        "itemPriceToppingArray"
      )
    );
    if (this.totalCartData[this.totalCartData.length - 1]) {
      this.$store.commit(keyMapsMutation.UPDATE_SELECTED_TOPPINGS, [
        LocalStorageFunc.getSelectedAndReplaceToppingsLocalStorage(
          "selectedAndReplacedToppings"
        ),
        this.totalCartData[this.totalCartData.length - 1].id,
      ]);
    } else {
      this.$store.commit(
        keyMapsMutation.UPDATE_SELECTED_TOPPINGS,
        LocalStorageFunc.getSelectedAndReplaceToppingsLocalStorage(
          "selectedAndReplacedToppings"
        )
      );
    }
    this.$store.commit(
      keyMapsMutation.UPDATE_CURRENT_SEL_TOPPING_OBJ,
      LocalStorageFunc.getCurrentSelectedToppings("currentSelToppObj")
    );

    if (
      this.productObserver &&
      this.dataCounterText &&
      document.getElementById(this.dataCounterText)
    ) {
      this.productObserver.observe(
        document.getElementById(this.dataCounterText)
      );
    }

    this.sectionName = this.dataType;
  },
  destroyed() {
    if (this.observer) {
      this.observer.unobserve(document.getElementById(this.dataCounterText));
    }
  },
  methods: {
    fireMoengageCartEvent(eventType, result, itemSelectedToppings = []) {
      const UserData = this.$store.state?.User || {};
      const moengageCartData =  Utility.getMoengageCartData(
        eventType,
        result,
        itemSelectedToppings,
        this.toppingFormStore,
        UserData,
        this.currentStoreDetails
      );
      setEvents("moengage", eventType, moengageCartData);
    },
    nonCustomiseHandler(e) {
      let returnObj = {
        subCategory: "banner",
        actionType: "add+",
        entryFrom: "banner",
        screenName:
          this.dataType == "searchModal"
            ? PageNames.NEXTGEN_SEARCH_NON_CUSTOMISATIONPAGE
            : PageNames.NEXTGEN_NON_CUSTOMISATIONPAGE,
        previousScreenname:
          this.dataType == "searchModal"
            ? PageNames.NEXTGEN_SEARCHPAGE
            : PageNames.NEXTGEN_HOMEPAGE,
      };

      this.eventFunction(true, returnObj);

      this.addToCart(e, "nonCustomizableCardAdd");
      this.closeNonCustomiseModal("nonCustomizableCardAdd");
    },
    closeNonCustomiseModal(source) {
      this.nonCustomiseModal = false;
      document.body.classList.remove("body-stop-scroll-mobile");

      let exp = this.$store.state.Config.vwoExperiments;
      setEvents("amplitude", "pageView", {
        [VWO_VARIANT_NEXTGEN_HOMEPAGE_HEADER_NAME]:
          exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT],
        Page_Name:
          this.dataType == "searchModal"
            ? PageNames.NEXTGEN_SEARCHPAGE
            : PageNames.NEXTGEN_HOMEPAGE,
        Previous_page:
          this.dataType == "searchModal"
            ? PageNames.NEXTGEN_SEARCH_NON_CUSTOMISATIONPAGE
            : PageNames.NEXTGEN_NON_CUSTOMISATIONPAGE,
      });

      if (source !== "cross") return;
      let returnObj = {
        subCategory: "banner",
        actionType: "cross tap",
        entryFrom: "banner",
        screenName:
          this.dataType == "searchModal"
            ? PageNames.NEXTGEN_SEARCH_NON_CUSTOMISATIONPAGE
            : PageNames.NEXTGEN_NON_CUSTOMISATIONPAGE,
        previousScreenname:
          this.dataType == "searchModal"
            ? PageNames.NEXTGEN_SEARCHPAGE
            : PageNames.NEXTGEN_HOMEPAGE,
      };

      this.eventFunction(true, returnObj);
    },
    itisvisible() {
      this.$emit("show-all-cards");
    },
    individualCardVisible() {
      if (
        !this.isUpdated &&
        this.result &&
        Object.keys(this.result).length > 2
      ) {
        this.eventFunction(false , {} , this.isNewEventCard ? this.isNewEventCard : false);
        this.isUpdated = true;
      }
      if(this.dataType === "reorder"){
        this.changeCounterText();
      }
    },
    eventFunction(isClicked = false, eObj = {} , isNewEventCardLikeTop10 = false) {
      if (!this.dataType) return;
      let eventType = isClicked ? "Click" : isNewEventCardLikeTop10 ? "nghFoodCarouselImpression" : "Impression";
      let userAction = isClicked ? "click" : isNewEventCardLikeTop10 ? "nghFoodCarouselImpression" : "Impression";
      let preEventObj = { ...eObj };
      if (isClicked) {
        preEventObj["isCustomisable"] =
          this.result.isCustomizable || this.itemIsCustomisableCrustSize
            ? "yes"
            : "no";
      }
      preEventObj = this.isStrikeThroughItemEvent(preEventObj);

      if (this.recommendateItem.length > 0)
        preEventObj["sellerType"] = "bestseller";
      if (this.dataType === "Recommended")
        preEventObj["popularityType"] =
          "popular in " + this.result?.customCategoryName?.toLowerCase();
      preEventObj["category"] = this.result?.name?.toLowerCase();

      if (this.dataType == "searchModal") {
        preEventObj["searchSection"] = "search bar";
        preEventObj = {
          ...preEventObj,
          ...this.$store.state.ProductItems.currentSearchData,
        };
        if (!preEventObj["screenName"]) {
          preEventObj["screenName"] = PageNames.NEXTGEN_SEARCHPAGE;
        }
      }

      if(isNewEventCardLikeTop10){
        preEventObj["storeID"] =  LocalStorageFunc.storeId();
        preEventObj["positionWithinSection"] = this.dataIndex + 1;
        preEventObj["Previous Page_Name"] = true;
      }

      if(this.isItemBogo && this.bogoItemTag != "") {
        preEventObj["item_tag"] = this.bogoItemTag;
      }

      const eventObj = Utility.amplitudeEventObj(
        userAction,
        this.dataType == "searchModal"
          ? "search"
          : this.dataType === "reorder"
          ? "previously ordered items card"
          : this.dataType.toLowerCase() + " card",
        this.dataType == "searchModal" ? "3" : this.dataType === "reorder" ? "4" : "11",
        preEventObj
      );

      if(isNewEventCardLikeTop10){
        //deleting as per event team for new type of carousal
        delete eventObj["previousScreenname"];
        delete eventObj["screenName"];
      }

      setEvents("amplitude", eventType, eventObj);
    },
    videoEventFunction(eventName, error) {
      const preEventObj = {
        category: this.result?.name?.toLowerCase(),
        positionWithinSection: this.dataIndex + 1,
        errorType: error,
      }
      const eventObj = Utility.amplitudeEventObj(
        eventName,
        this.dataType.toLowerCase() + " card",
        "11",
        preEventObj,
      );
      setEvents("amplitude", eventName, eventObj);
    },
    checkItemCustomizedChanges() {
      if (
        this.result.defaultSizeName !== this.result.sizeName ||
        this.result.defaultCrustName !== this.result.crustName
      ) {
        return true;
      } else {
        return false;
      }
    },
    checkReplaceToppingChanges() {
      if (this.result.repTopngs?.length > 0) {
        return true;
      } else return false;
    },
    itemIsCustomized() {
      if (
        this.checkItemCustomizedChanges() ||
        this.result?.addTopngs?.length > 0 ||
        this.checkReplaceToppingChanges()
      ) {
        return true;
      } else {
        return false;
      }
    },
    repeatLastCustomization(e, source) {
      //add new pizza event
      if (this.dataType) {
        let preEventObj = this.getNewPizzaEventObj();
        switch (source) {
          case "addMinusBtn":
            preEventObj["subCategory"] = "add+";
            preEventObj["customisationType"] = "repeat last customisation";
            preEventObj["screenName"] = "repeat last customisation popup";
            break;
          default:
            preEventObj["subCategory"] = source;
        }
        const eventObj = Utility.amplitudeEventObj(
          "click",
          this.dataType == "searchModal"
            ? "search"
            : this.dataType === "reorder"
            ? "previously ordered items card"
            : this.dataType.toLowerCase() + " card",
          this.dataType === "reorder" ? "4" : "11",
          preEventObj
        );
        setEvents("amplitude", "Click", eventObj);
      }
      this.islastEditOn = false;
      this.$store.commit(keyMapsMutation.UPDATE_CART, [
        this.result,
        this.islastEditOn,
      ]);
      this.$store.commit(keyMapsMutation.ADD_TO_UNIQUE_CART_ITEMS, {
        id: this.result.id,
      });
      this.closeRepeatOrAddModal(e, source);
      e.stopPropagation();
      if (this.replacedToppingText[this.result.id]?.length > 0) {
        this.$store.commit(keyMapsMutation.UPDATE_DISABLE_REPLACE_NAME, true);
      } else {
        this.$store.commit(keyMapsMutation.UPDATE_DISABLE_REPLACE_NAME, false);
      }
      this.$store.commit(
        keyMapsMutation.IS_ITEM_NEW_OR_PREVIOUS_ON_CHECK,
        false
      ); // for checking the added item in new one or previous one
      let preObj = {
        type: "ADD",
        source: this.dataType,
        item: this.result,
        sectionName:
          this.dataType === "reorder"
            ? "previously ordered items card"
            : this.dataType.toLowerCase() + " card",
        sectionPosition: this.dataType === "reorder" ? "4" : "11",
        positionWithinSection: this.dataIndex + 1,
      };
      preObj = this.isStrikeThroughItemEvent(preObj);
      this.$store.commit(
        keyMapsMutation.TRIGGER_INITIAL_CART_UPDATED_BY_USER_ACTION_REF,
        preObj
      );
      if(this.isItemPizza){
        this.$store.commit(keyMapsMutation.UPDATE_CROSS_SELL_WITH_PRODUCT, {
          productId: this.result.code,
          categoryId: this.dataCategoryId,
        });
      }
    },
    addToCart(e, source = "") {
      e.stopPropagation();
      let result = {};
      if(this.itemQuantity == 0) {
        result = Utility.deepCopyArry(this.result);
      } else {
        result = this.result;
      }

      if (!this.cardSearchable) {
        userActivityTracking.itemAdded(
          this.result?.product?.id,
          this.itemQuantity + 1,
          0
        );
      } else {
        userActivityTracking.searchSelected(
          this.result?.product?.id,
          this.itemQuantity + 1,
          3
        );
      }

      if(this.isItemBogo) {
        this.applyBogoOffer();
      }

      if (
        this.customizableCardExperiment &&
        Number(this.itemQuantity) === 0 &&
        (this.result.isCustomizable || this.itemIsCustomisableCrustSize)
      ) {
        // customisation option will popup directly when we will have added our first item to the cart
        this.triggerModal(e, "addMinusBtn");
      } else {
        if (
          (this.dataType === "reorder" &&
            Number(this.itemQuantity) !== 0 &&
            this.itemIsCustomized()) ||
          (this.dataType !== "reorder" && this.itemIsCustomized())
        ) {
          this.triggerRepeatOrAddModal();
        } else {
          this.$store.commit(keyMapsMutation.ADD_TO_CART, result);
          this.$store.commit(keyMapsMutation.ADD_TO_UNIQUE_CART_ITEMS, {
            id: this.result.id,
          });
          // this.$store.commit("UniqueCartItems/addToCart", this.productResult);
          let preObj = {
              type: "ADD",
              source: this.dataType,
              subSource: source,
              item: result,
              sectionName:
                this.dataType == "searchModal"
                  ? "search"
                  : this.dataType === "reorder"
                  ? "previously ordered items card"
                  : this.dataType.toLowerCase() + " card",
              sectionPosition: this.dataType == "searchModal" ? "3" : this.dataType === "reorder" ? "4" : "11",
              positionWithinSection: this.dataIndex + 1,
              isItemBogo: this.isItemBogo,
              bogoItemTag: this.bogoItemTag
            };
          preObj = this.isStrikeThroughItemEvent(preObj);
          this.$store.commit(
            keyMapsMutation.TRIGGER_INITIAL_CART_UPDATED_BY_USER_ACTION_REF,
            preObj
          );
          if(this.isItemPizza){
              this.$store.commit(keyMapsMutation.UPDATE_CROSS_SELL_WITH_PRODUCT, {
              productId: this.result.code,
              categoryId: this.dataCategoryId,
            });
          }
        }
        if (this.dataType && source != "nonCustomizableCardAdd") {
          let eObj = {
            subCategory: "add+",
            addCounter: JSON.stringify(this.itemQuantity),
            positionWithinSection: this.dataIndex + 1,
          };
          this.eventFunction(true, eObj);
          this.fireMoengageCartEvent('Add To Cart', result);
        }
        this.$emit("add-to-cart", result);
        this.scrollCrossSellIntoView();
      }
    },
    removeFromCart(e) {
      e.stopPropagation();
      const itemSelectedToppings = [...this.result?.addTopngs] || [];
      if (this.newItemRemoveFeature) {
        let obj = Utility.deepCopyArry(this.result);
        const itemPrice = this.itemIsCustomized 
                        ? this.getTotalCustomisedPriceWithToppings
                        : this.result.itemPrice
        this.$store.commit(keyMapsMutation.NEW_FEATURE_REMOVE_CART, {
          id: this.result.id,
          itemPrice
        });
        this.$store.commit(keyMapsMutation.REMOVE_CURRENT_SEL_TOPPING_OBJ, obj);
        this.$store.commit(keyMapsMutation.REMOVE_FROM_UNIQUE_CART_ITEMS, {
          id: this.result.id,
        });
        if (
          this.result.addTopngs?.length !== undefined &&
          this.result.addTopngs.length > 0
        ) {
          let data = Utility.toppingsNameByToppingId(
            this.allCartToppingItem,
            this.toppingFormStore,
            this.result.addTopngs
          ).split(",");
          data &&
            this.$store.commit(
              keyMapsMutation.UPDATE_PREVIOUS_SELECTED_TOPPINGS,
              [data, this.result.id]
            );
        }
        if (
          this.toppingFormStore &&
          this.toppingFormStore.length > 0 &&
          this.allCartToppingItem &&
          this.allCartToppingItem.length > 0
        ) {
          let selec = this.toppingFormStore.filter((i) =>
            this.allCartToppingItem[
              this.allCartToppingItem.length - 1
            ].addTopngs.includes(i.toppingId)
          );
          selec &&
            this.$store.commit(
              keyMapsMutation.UPDATE_CURRENT_SEL_TOPPING_OBJ,
              selec
            );
        }
      } else {
        if (!this.itemIsCustomized()) {
          this.$store.commit(keyMapsMutation.REMOVE_FROM_CART, this.result);
          this.$store.commit(keyMapsMutation.REMOVE_FROM_UNIQUE_CART_ITEMS, {
            id: this.result.id,
          });
        }
      }
      if (this.allCartToppingItem) {
        // this condition is for check if there
        this.islastEditOn = false;
      }
      let preObj = {
        type: "REMOVE",
        source: this.dataType,
        item: this.result,
        sectionName:
          this.dataType === "reorder"
            ? "previously ordered items card"
            : this.dataType.toLowerCase() + " card",
        sectionPosition: this.dataType == "searchModal" ? "3" : this.dataType === "reorder" ? "4" : "11",
        positionWithinSection: this.dataIndex + 1,
      };
      preObj = this.isStrikeThroughItemEvent(preObj);
      this.$store.commit(
        keyMapsMutation.TRIGGER_INITIAL_CART_UPDATED_BY_USER_ACTION_REF,
        preObj
      );

      if (this.dataType) {
        let eObj = {
          subCategory: "add-",
          addCounter: JSON.stringify(this.itemQuantity),
          positionWithinSection: this.dataIndex + 1,
        };
        this.eventFunction(true, eObj);
        this.fireMoengageCartEvent('Remove From Cart', this.result, itemSelectedToppings);
      }
      userActivityTracking.itemRemoved(
        this.result.product.id,
        this.itemQuantity,
        this.cardSearchable ? 3 : 0
      );
    },
    applyBogoOffer() {
      const bogoCouponDetail = this.getBogoConfig?.autoApplyOfferDetail || {};
      const {
        confettiMessage = '',
        couponCode = '',
        displayMsgOnSelection = '',
        nudgeMessage = '',
        nudgeSubTitleMessage = '',
        promoCode = '',
        title = ''
      } = bogoCouponDetail;
      const welcomeOffers = this.$store.state.Offers.welcomeOffers;
      const couponIndex = welcomeOffers.findIndex(offer => {
        return offer.couponCode === couponCode && offer.promoCode === promoCode;
      });
      const selectedOfferIndex = this.$store.state.Offers.selectedOfferIndex;
      if(couponIndex >= 0 && selectedOfferIndex != couponIndex) {
        this.$store.commit(keyMapsMutation.UPDATE_SHOW_CONFETTI_FLAG, false);
        this.$store.commit(keyMapsMutation.UPDATE_SELECTED_OFFER_INDEX, couponIndex);
        LocalStorageFunc.updateCouponCode(promoCode);
        // update confetti message and props
        this.$store.commit(keyMapsMutation.UPDATE_CONFETTI_PROPS, {
          heading: `${couponCode} applied`,
          subHeading: confettiMessage
        });
        const isConfettiPlayed = this.$store.state.DynamicConfetti.confettiPlayed;
        if(!isConfettiPlayed) {
          this.$store.commit(keyMapsMutation.UPDATE_SHOW_CONFETTI_FLAG, true);
          setTimeout(() => {
            this.$store.commit(keyMapsMutation.UPDATE_SHOW_CONFETTI_FLAG, false);
          }, 3000);
        }
      }
    },
    isStrikeThroughItemEvent(preObj) {
      if(this.checkIfValidStrikePrice) {
        preObj = {
          ...preObj,
          mealOriginalPrice: this.mealOriginalPrice,
          mealFinalPrice: this.mealFinalPrice,
          mealSavings: this.mealSavingPrice
        };
      }
      return preObj;
    },
    getDataFromSelectedSize(data) {
      let sizeArr = data[0].sizes ? data[0].sizes : [];
      let selectedSizeArr = sizeArr.filter((s) => {
        return s.sizeId == this.result.sizeId;
      });
      return {
        size: selectedSizeArr[0].name,
        price: selectedSizeArr[0].price,
        sizeId: selectedSizeArr[0].sizeId,
        code: selectedSizeArr[0].code,
      };
    },
    openCustomizedPopUp(e, source) {
      e.stopPropagation();
      //  open popup customized modal
      if (this.itemQuantity > 0 && this.itemIsCustomized()) {
        this.triggerAddOrEditCheckModal(e, source);
      }
    },
    getNewPizzaEventObj() {
      let returnObj = {
        positionWithinSection: this.dataIndex + 1,
        category: this.result?.name.toLowerCase(),
        isCustomisable:
          this.result.isCustomizable || this.itemIsCustomisableCrustSize
            ? "yes"
            : "no",
      };
      if (this.dataType == "searchModal") {
        returnObj["screenName"] = PageNames.NEXTGEN_SEARCH_CUSTOMISATIONPAGE;
        returnObj["previousScreenname"] = PageNames.NEXTGEN_HOMEPAGE;
        returnObj["searchSection"] = "search bar";
        returnObj = {
          ...returnObj,
          ...this.$store.state.ProductItems.currentSearchData,
        };
      }
      return returnObj;
    },
    addANewPizza(e, source) {
      source === "custBtn" ||
      source === "customiseBtn" ||
      source === "banner" ||
      source === "crustNSize"
        ? this.closeAddOrEditCheckModal(e, source)
        : this.closeRepeatOrAddModal(e, source);
      this.showCustmizationModal = true;
      this.customisePopupSource = source;
      this.islastEditOn = false;
      this.$store.commit(keyMapsMutation.UPDATE_DISABLE_REPLACE_NAME, false);
      this.$store.commit(
        keyMapsMutation.IS_ITEM_NEW_OR_PREVIOUS_ON_CHECK,
        true
      ); // for checking the added item in new one or previous one

      //add new pizza event
      if (this.dataType) {
        let preEventObj = this.getNewPizzaEventObj();
        switch (source) {
          case "customiseBtn":
            preEventObj["subCategory"] = this.getSubCategory(source);
            preEventObj["updateType"] = "add a new pizza";
            preEventObj["screenName"] = "add edit last pizza popup";
            preEventObj["previousScreenname"] =
              this.dataType == "searchModal"
                ? PageNames.NEXTGEN_SEARCHPAGE
                : PageNames.NEXTGEN_HOMEPAGE;
            break;
          case "crustNSize":
            preEventObj["subCategory"] = this.getSubCategory(source);
            preEventObj["updateType"] = "add a new pizza";
            preEventObj["screenName"] = "add edit last pizza popup";
            preEventObj["previousScreenname"] =
              this.dataType == "searchModal"
                ? PageNames.NEXTGEN_SEARCHPAGE
                : PageNames.NEXTGEN_HOMEPAGE;
            break;
          case "banner":
            preEventObj["subCategory"] = this.getSubCategory(source);
            preEventObj["updateType"] = "add a new pizza";
            preEventObj["screenName"] = "add edit last pizza popup";
            preEventObj["previousScreenname"] =
              this.dataType == "searchModal"
                ? PageNames.NEXTGEN_SEARCHPAGE
                : PageNames.NEXTGEN_HOMEPAGE;
            break;
          case "addMinusBtn":
            preEventObj["subCategory"] = this.getSubCategory(source);
            preEventObj["customisationType"] = "add new customisation";
            preEventObj["screenName"] = "repeat last customisation popup";
            preEventObj["previousScreenname"] =
              this.dataType == "searchModal"
                ? PageNames.NEXTGEN_SEARCHPAGE
                : PageNames.NEXTGEN_HOMEPAGE;
            break;
          case "custBtn":
            preEventObj["subCategory"] = this.getSubCategory(source);
            preEventObj["updateType"] = "add a new pizza";
            preEventObj["screenName"] = "add edit last pizza popup";
            preEventObj["previousScreenname"] =
              this.dataType == "searchModal"
                ? PageNames.NEXTGEN_SEARCHPAGE
                : PageNames.NEXTGEN_HOMEPAGE;
          default:
            preEventObj["subCategory"] = source;
        }
        const eventObj = Utility.amplitudeEventObj(
          "click",
          this.dataType == "searchModal"
            ? "search"
            : this.dataType === "reorder"
            ? "previously ordered items card"
            : this.dataType.toLowerCase() + " card",
          this.dataType === "reorder" ? "4" : "11",
          preEventObj
        );
        setEvents("amplitude", "Click", eventObj);
      }
    },
    editLastAddedPizza(e, source) {
      e.stopPropagation();
      /* this.result = this.totalCartData[this.totalCartData.length - 1]; */
      this.closeAddOrEditCheckModal(e, source);
      this.showCustmizationModal = true;
      this.customisePopupSource = source;
      this.islastEditOn = true;
      if (this.replacedToppingText[this.result.id]?.length > 0) {
        this.$store.commit(keyMapsMutation.UPDATE_DISABLE_REPLACE_NAME, true);
      } else {
        this.$store.commit(keyMapsMutation.UPDATE_DISABLE_REPLACE_NAME, false);
      }
      if(this.dataType === 'reorder' && this.result?.remTopngs?.length > 0 && this.result?.repTopngs?.length > 0){
        this.$store.commit(keyMapsMutation.UPDATE_DISABLE_REPLACE_NAME, true);
      }
      this.$store.commit(
        keyMapsMutation.IS_ITEM_NEW_OR_PREVIOUS_ON_CHECK,
        false
      ); // for checking the added item in new one or previous one

      //add new pizza event
      if (this.dataType && source !== "directFunctionCall") {
        let preEventObj = this.getNewPizzaEventObj();
        switch (source) {
          case "customiseBtn":
            preEventObj["subCategory"] = this.getSubCategory(source);
            preEventObj["updateType"] = "edit last added pizza";
            break;
          case "custBtn":
            preEventObj["subCategory"] = this.getSubCategory(source);
            preEventObj["updateType"] = "edit last added pizza";
            break;
          case "crustNSize":
            preEventObj["subCategory"] = this.getSubCategory(source);
            preEventObj["updateType"] = "edit last added pizza";
            break;
          case "banner":
            preEventObj["subCategory"] = this.getSubCategory(source);
            preEventObj["updateType"] = "edit last added pizza";
            break;
          default:
            preEventObj["subCategory"] = source;
        }

        preEventObj["screenName"] = "add edit last pizza popup";

        const eventObj = Utility.amplitudeEventObj(
          "click",
          this.dataType == "searchModal"
            ? "search"
            : this.dataType === "reorder"
            ? "previously ordered items card"
            : this.dataType.toLowerCase() + " card",
          this.dataType === "reorder" ? "4" : "11",
          preEventObj
        );
        setEvents("amplitude", "Click", eventObj);
      }
    },
    triggerOnlyCustomisationModal(e, source) {
      document.body.classList.add("body-stop-scroll-mobile");
      if (this.itemIsCustomized() && this.itemQuantity > 0) {
        this.showCustmizationModal = false;
      } else {
        this.showCustmizationModal = true;
        this.customisePopupSource = source;
      }
      this.openCustomizedPopUp(e, source);
      if (this.dataType) {
        this.eventFunction(true, {
          subCategory: this.getSubCategory(),
          positionWithinSection: this.dataIndex + 1,
          screenName:
            this.dataType == "searchModal"
              ? PageNames.NEXTGEN_SEARCHPAGE
              : PageNames.NEXTGEN_HOMEPAGE,
          previousScreenname:
            this.dataType == "searchModal" ? PageNames.NEXTGEN_HOMEPAGE : "",
        });
      }
      if (
        this.replaceTopDis().length > 0 ||
        (this.dataType === "reorder" &&
          this.result?.repTopngs?.length > 0 &&
          this.result?.remTopngs?.length > 0)
      ) {
        this.$store.commit(keyMapsMutation.UPDATE_DISABLE_REPLACE_NAME, true);
      } else {
        this.$store.commit(keyMapsMutation.UPDATE_DISABLE_REPLACE_NAME, false);
      }
      let eventName = "open-customise";
      if (source == "crustNSize") eventName = "open-upsell";
      this.$emit(eventName, this.result);
    },
    triggerModal(e, source) {
      this.customisePopupSource = source;
      if (this.result.isCustomizable || this.itemIsCustomisableCrustSize) {
        if (Number(this.itemQuantity) === 1) {
          //  i have added a feature which allow me to customise first added item
          this.editLastAddedPizza(e, "directFunctionCall");
          if (this.dataType) {
            this.eventFunction(true, {
              subCategory: this.getSubCategory(),
              positionWithinSection: this.dataIndex + 1,
              screenName:
                this.dataType == "searchModal"
                  ? PageNames.NEXTGEN_SEARCHPAGE
                  : PageNames.NEXTGEN_HOMEPAGE,
              previousScreenname:
                this.dataType == "searchModal"
                  ? PageNames.NEXTGEN_HOMEPAGE
                  : "",
            });
          }
        } else {
          e.stopPropagation();
          if (
            this.dataType === "reorder" &&
            this.itemIsCustomized() &&
            Number(this.itemQuantity) === 0
          ) {
            this.islastEditOn = true;
          }
          this.triggerOnlyCustomisationModal(e, source);
        }
      } else if (this.result?.images?.length > 0 || this.result?.image) {
        document.body.classList.add("body-stop-scroll-mobile");
        this.nonCustomiseModal = true;

        let exp = this.$store.state.Config.vwoExperiments;
        setEvents("amplitude", "pageView", {
          [VWO_VARIANT_NEXTGEN_HOMEPAGE_HEADER_NAME]:
            exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT],
          Page_Name:
            this.dataType == "searchModal"
              ? PageNames.NEXTGEN_SEARCH_NON_CUSTOMISATIONPAGE
              : PageNames.NEXTGEN_NON_CUSTOMISATIONPAGE,
          Previous_page:
            this.dataType == "searchModal"
              ? PageNames.NEXTGEN_SEARCHPAGE
              : PageNames.NEXTGEN_HOMEPAGE,
        });

        if (this.dataType) {
          let preEventObj = {
            ...this.getNewPizzaEventObj(),
            subCategory: "banner",
            screenName:
              this.dataType == "searchModal"
                ? PageNames.NEXTGEN_SEARCHPAGE
                : PageNames.NEXTGEN_HOMEPAGE,
            previousScreenname:
              this.dataType == "searchModal" ? PageNames.NEXTGEN_HOMEPAGE : "",
          };

          const eventObj = Utility.amplitudeEventObj(
            "click",
            this.dataType == "searchModal"
              ? "search"
              : this.dataType === "reorder"
              ? "previously ordered items card"
              : this.dataType.toLowerCase() + " card",
            this.dataType == "searchModal" ? "3" : this.dataType === "reorder" ? "4" : "11",
            preEventObj
          );
          setEvents("amplitude", "Click", eventObj);
        }
      }
    },
    getSubCategory() {
      let subCategory = "";
      switch (this.customisePopupSource) {
        case "customiseBtn":
          subCategory = "customise";
          break;
        case "crustNSize":
          subCategory = "crust & size";
          break;
        case "banner":
          subCategory = "banner";
          break;
        case "addMinusBtn":
          subCategory = "add+";
          break;
        case "custBtn":
          subCategory = "customise";
          break;
        default:
          subCategory = "";
      }
      return subCategory;
    },
    closeCustomizationModal(e, source) {
      e.stopPropagation();
      this.showCustmizationModal = false;
      document.body.classList.remove("body-stop-scroll-mobile");

      let exp = this.$store.state.Config.vwoExperiments;
      setEvents("amplitude", "pageView", {
        [VWO_VARIANT_NEXTGEN_HOMEPAGE_HEADER_NAME]:
          exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT],
        Page_Name:
          this.dataType == "searchModal"
            ? PageNames.NEXTGEN_SEARCHPAGE
            : PageNames.NEXTGEN_HOMEPAGE,
        Previous_page:
          this.dataType == "searchModal"
            ? PageNames.NEXTGEN_SEARCH_CUSTOMISATIONPAGE
            : PageNames.NEXTGEN_CUSTOISATIONPAGE,
      });

      if (this.dataType) {
        if (source && source == "cross") {
          let preEventObj = {
            ...this.getNewPizzaEventObj(),
            entryFrom: this.getSubCategory(),
            category: this.result?.name?.toLowerCase(),
            subCategory: this.getSubCategory(),
            actionType: "cross tap",
            changeSize: this.result?.sizeName.toLowerCase(),
            changeCrust: this.result?.crustName.toLowerCase(),
            addVegToppings: "none",
            addNonVegToppings: "none",
            replaceToppings: "0",
            screenName:
              this.dataType == "searchModal"
                ? PageNames.NEXTGEN_SEARCH_CUSTOMISATIONPAGE
                : PageNames.NEXTGEN_CUSTOISATIONPAGE,
            previousScreenname:
              this.dataType == "searchModal"
                ? PageNames.NEXTGEN_SEARCHPAGE
                : PageNames.NEXTGEN_HOMEPAGE,
          };
          if (this.dataType == "searchModal") {
            preEventObj["searchSection"] = "search bar";
            preEventObj = {
              ...preEventObj,
              ...this.$store.state.ProductItems.currentSearchData,
            };
          }
          const eventObj = Utility.amplitudeEventObj(
            "click",
            this.dataType == "searchModal"
              ? "search"
              : this.dataType === "reorder"
              ? "previously ordered items card"
              : this.dataType.toLowerCase() + " card",
            this.dataType == "searchModal" ? "3" : this.dataType === "reorder" ? "4" : "1",
            preEventObj
          );
          setEvents("amplitude", "Click", eventObj);
        }
      }
    },
    triggerAddOrEditCheckModal(e, source) {
      e.stopPropagation();
      document.body.classList.add("body-stop-scroll-mobile");
      this.showAddOrEditCheckModalSource = source;
      this.showAddOrEditCheckModal = true;
    },
    closeAddOrEditCheckModal(e, source) {
      e.stopPropagation();
      document.body.classList.remove("body-stop-scroll-mobile");
      this.showAddOrEditCheckModalSource = "";
      this.showAddOrEditCheckModal = false;
      if (source && source == "crossCustBtn") {
        //add new pizza event
        if (this.dataType) {
          let preEventObj = this.getNewPizzaEventObj();
          switch (source) {
            case "customiseBtn":
            case "crustNSize":
            case "banner":
              preEventObj["subCategory"] = "cross tap";
              break;
            default:
              preEventObj["subCategory"] = source;
          }
          const eventObj = Utility.amplitudeEventObj(
            "click",
            this.dataType == "searchModal"
              ? "search"
              : this.dataType === "reorder"
              ? "previously ordered items card"
              : this.dataType.toLowerCase() + " card",
            this.dataType === "reorder" ? "4" : "11",
            preEventObj
          );
          setEvents("amplitude", "Click", eventObj);
        }
      }
    },
    closeDisableButtonModal() {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.disbaleButtonModal = false;
    },
    triggerDisableButtonModal() {
      document.body.classList.add("body-stop-scroll-mobile");
      this.disbaleButtonModal = true;
    },
    triggerRepeatOrAddModal() {
      document.body.classList.add("body-stop-scroll-mobile");
      this.showRepeatOrAddCustomizationModal = true;
    },
    closeRepeatOrAddModal(e, source) {
      e.stopPropagation();
      document.body.classList.remove("body-stop-scroll-mobile");
      this.showRepeatOrAddCustomizationModal = false;
    },
    closeRepeatOrAddModalThroughCrossTap(e, source) {
      //add new pizza event
      if (this.dataType) {
        let preEventObj = this.getNewPizzaEventObj();
        switch (source) {
          case "addMinusBtn":
            preEventObj["subCategory"] = "cross tap";
            preEventObj["screenName"] = "repeat last customisation popup";
            preEventObj["previousScreenname"] =
              this.dataType == "searchModal"
                ? PageNames.NEXTGEN_SEARCHPAGE
                : PageNames.NEXTGEN_HOMEPAGE;
            break;
          default:
            preEventObj["subCategory"] = source;
        }
        const eventObj = Utility.amplitudeEventObj(
          "click",
          this.dataType == "searchModal"
            ? "search"
            : this.dataType === "reorder"
            ? "previously ordered items card"
            : this.dataType.toLowerCase() + " card",
          this.dataType === "reorder" ? "4" : "11",
          preEventObj
        );
        setEvents("amplitude", "Click", eventObj);
      }

      e.stopPropagation();
      document.body.classList.remove("body-stop-scroll-mobile");
      this.showRepeatOrAddCustomizationModal = false;
    },
    currentToppings(item) {
      // to get the current toppings name
      let theMainArray = [];
      if (this.dataType === "reorder") {
        if (this.itemQuantity === 0 && this.itemIsCustomized()) {
          theMainArray = [this.result];
        }
      }

      if (this.allCartToppingItem?.length !== undefined) {
        return Utility.toppingsNameByToppingId(
          theMainArray.length > 0 ? theMainArray : this.allCartToppingItem,
          this.toppingFormStore,
          item,
          this.dataType
        )
          .split(",")
          .join(", ");
      }
    },
    currentCrust() {
      // current selected crust which will display on main Pizza Cart
      if (this.totalCartData.length > 0 && this.result) {
        return Utility.currentCrustName(this.totalCartData, this.result);
      }
    },
    currentSize() {
      // current selected size which will display on main Pizza Cart
      if (this.totalCartData.length > 0 && this.result) {
        return Utility.currentSizeName(this.totalCartData, this.result);
      }
    },
    replaceTopDis() {
      return (
        Utility.replaceToppingText(
          this.allCartToppingItem,
          this.toppingFormStore,
          this.result
        ) || ""
      );
    },
    getTotalToppingPrice() {
      const addedToppings = this.result?.addTopngs;
      let total = 0;
      addedToppings.forEach((i) => {
        total += Number(
          this.showToppingPrice(
            this.toppingFormStore.find(
              (j) => Number(j?.toppingId) === Number(i)
            )?.price
          )
        );
      });
      return total;
    },
    showToppingPrice(data) {
      if (!data) return 0;
      // created a custom function to show the price according to sizes
      switch (this.result.sizeName) {
        case "Regular":
          return data[6];
          break;
        case "Medium":
          return data[7];
          break;
        case "Large":
          return data[8];
          break;
        default:
          return data[6];
          break;
      }
    },
    changeCounterText(){
      this.$emit("change-counter-text" , this.dataIndex+1);
    },
    scrollCrossSellIntoView() {
      if(this.itemQuantity >= 1) {
        setTimeout(() => {
          if(this.$refs.upsellAndCrossSell?.clientHeight) {
            const elementRect = this.$refs.upsellAndCrossSell.getBoundingClientRect();
            const elementTopInView = elementRect.top >= 0 && elementRect.top <= window.innerHeight;
            const elementBottomInView = elementRect.bottom >= 0 && elementRect.bottom <= window.innerHeight - 65;
            if(!elementTopInView || !elementBottomInView) {
              this.$refs.upsellAndCrossSell?.scrollIntoView({
                block: "center",
                behavior: "smooth",
              });
            }
          }
        }, 300);
      }
    },
  },
  computed: {
    getCardVariationName() {
      return this.$store.state.Config.vwoExperiments;
    },
    cardSearchable() {
      let linkRewrite = Utility.getCurrentStoreFolder();
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        (this.cardSource !== "HPS" &&
          exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] === "nextgen_variant_b") ||
        (exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_U &&
          linkRewrite === Utility.getMenuCategory()) ||
        this.cardSource === "reorder"
      ) {
        return true;
      } else {
        let frmProps =
          this.dataCardSearchable != "null" &&
          typeof this.dataCardSearchable != "undefined"
            ? this.dataCardSearchable
            : false;
        return frmProps;
      }
    },
    uniqueQuantity() {
      return this.$store.getters[keyMapsGetter.GET_UNIQUE_CART_ITEMS](
        this.result
      );
    },
    itemQuantity() {
      let quant = this.$store.getters[keyMapsGetter.GET_ITEM_QUANTITY](this.result);
      if(!this.crossSellWithProduct && quant > 0 && this.isItemPizza){
        this.$store.commit(keyMapsMutation.UPDATE_CROSS_SELL_WITH_PRODUCT, {
          productId: this.result.code,
          categoryId: this.dataCategoryId,
        });
      }
      return quant;
    },
    recommendateItem() {
      return this.$store.state.ProductItems.recommendedItemsIds.includes(
        this.result.code
      ) && this.dataType !== "Recommended"
        ? "BESTSELLER"
        : "";
    },
    getBestSellerIds() {
      return this.$store.getters[keyMapsGetter.GET_BEST_SELLER_ITEMS_ID];
    },
    crossSellWithProduct() {
      return this.$store.state.Cart.crossSellWithProduct;
    },
    selectedStoreToppings() {
      return (
        this.$store.state.Cart.selectedAndReplacedToppings.addedToppings || {}
      );
    },
    replacedToppingText() {
      return (
        this.$store.state.Cart.selectedAndReplacedToppings.replacedToppings ||
        {}
      );
    },
    totalCartData() {
      return this.$store.state.Cart.cartItems || [];
    },
    ifAddedTextShow() {
      return this.totalCartData[this.totalCartData.length - 1]?.addTopngs !==
        undefined &&
        this.totalCartData[this.totalCartData.length - 1]?.addTopngs.length > 0
        ? true
        : false;
      // @todo
      // let text = false;
      //   if(this.totalCartData[this.totalCartData.length - 1]?.addTopngs !==
      //   undefined){
      //     this.totalCartData.map(i => {
      //       if([i.addTopngs].sort().toString() == [this.result.addTopngs].sort().toString()){
      //         text = true;
      //       } else {
      //         text = false;
      //       }
      //       })
      //   }
      //   return text;
    },
    ifReplaceTextShow() {
      return this.totalCartData[this.totalCartData.length - 1]?.repTopngs !==
        undefined &&
        this.totalCartData[this.totalCartData.length - 1]?.repTopngs.length > 0
        ? true
        : false;
    },
    result() {
      let _ =
        this.$store.getters[keyMapsGetter.GET_CART_ITEM_LATEST](
          this.dataResult?.id
        ) ||
        this.dataResult ||
        {};
      
      if(!_?.isCustomizable && this.dataResult?.crust?.length > 1){ //for isCustomisable flag false - if crust/size is customisable
        _["isCustomisableWrtCrustSize"] = true;
      }  

      _["isUserCustomizable"] =
        this.dataResult?.addTopngs?.length > 0 ? true : false;
      return _;
    },
    productObserver() {
      let observer = this.$store.state.ProductItems.productObserver;
      if (
        observer &&
        this.dataCounterText &&
        document.getElementById(this.dataCounterText)
      ) {
        observer.observe(document.getElementById(this.dataCounterText));
      }
      return observer;
    },
    hideToppingInRecommendedItems() {
      return this.dataType !== "Recommended" ? true : false;
    },
    allCartToppingItem() {
      return this.$store.state.Cart.cartItems || [];
    },
    toppingFormStore() {
      return this.$store.state.Cart.toppingItems;
    },
    customizableCardExperiment() {
      // for experiment a/b
      return false;
    },
    // isSeparateMenuVariant() {
    //   // for experiment a/b
    //   let exp = this.$store.state.Config.vwoExperiments;
    //   if (exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] === "nextgen_variant_u") {
    //     // return { rootMargin: '-157px 150px 0px 150px'};
    //     // return { rootMargin: '-50px 0px -1% 0px'};
    //     return { rootMargin: '0px 0px 0px 0px'};
    //   } else {
    //     return { rootMargin: '600px' };
    //   }
    // },
    SeparateMenuLoadImage() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] === "nextgen_variant_u" ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] === "nextgen_variant_y"
      ) {
        return true;
      } else {
        return false;
      }
    },
    getTotalCustomisedPriceWithToppings() {
      if (
        this.itemQuantity >= 0 &&
        this.result?.addTopngs?.length &&
        this.toppingFormStore?.length
      ) {
        if (this.result?.itemPrice === this.result?.defaultPrice)
          return Number(this.result.itemPrice) + this.getTotalToppingPrice();
        else return this.result.itemPrice;
      } else return this.result.itemPrice;
    },
    itemIsCustomisableCrustSize() {
      if (
        (
          !this.result.isCustomizable && 
            (
              this.result?.crust?.length > 1 || 
              ( this.result?.crust?.length === 1 && this.result?.crust[0]?.sizes?.length > 1 )
            )
        ) || 
        (this.result["isCustomisableWrtCrustSize"] !== undefined && this.result["isCustomisableWrtCrustSize"])
      ) {
        return true;
      } else {
        return false;
      }
    },
    showingUpSell() {
      return this.showUpsell && this.itemQuantity == 1;
    },
    showingCrossSell() {
      // return (
      //   this.showCrossell &&
      //   ((!this.crossSellWithProduct && this.itemQuantity == 1) ||
      //     this.crossSellWithProduct.productId == this.result.code)
      // );
      return (
        this.showCrossell &&
          this.crossSellWithProduct.productId === this.result.code
      );
    },
    showingCrossSellOrUpSell() {
      return this.showingCrossSell || this.showingUpSell;
    },
    isProductVeg() {
      return (
        this.result.tempProductType === 0 ||
        this.result.productType === 0 ||
        (Number.isNaN(+this.result.tempProductType) &&
          Number.isNaN(+this.result.productType) &&
          !this.result.nonVeg)
      );
    },
    isProductNonveg() {
      return (
        this.result.tempProductType === 1 ||
        this.result.productType === 1 ||
        (Number.isNaN(+this.result.tempProductType) &&
          Number.isNaN(+this.result.productType) &&
          this.result.nonVeg)
      );
    },
    isVideoCard() {
      return videoSwitch && this.cardSource === "VPS" && this.result.videos && this.result.videos.length;
    },
    checkIfValidStrikePrice() {
      const {crustId = "" , sizeId = "" , crust = [] , itemPrice} = this.result;
      if(crust.length){
        const {originalPrice = 0 , price = 0  } = crust?.filter(item => item.crustId == crustId)[0]?.sizes?.filter((item) => item.sizeId == sizeId)[0] || {};
        const priceWrtCrustSize = price;
        const toppingPrice = itemPrice - priceWrtCrustSize;

        this.mealOriginalPrice = originalPrice;
        if(toppingPrice){
          this.mealOriginalPrice  = this.mealOriginalPrice + toppingPrice;
        }
        this.mealFinalPrice = itemPrice;      
      }
      else{ 
        const { defaultPrice = 0, originalPrice = 0 } = this.result;
        this.mealOriginalPrice = originalPrice;
        this.mealFinalPrice = defaultPrice;
      }
      this.mealSavingPrice = this.mealOriginalPrice - this.mealFinalPrice;
      return this.mealSavingPrice > 0 ? true : false;
    },
    isItemPizza(){
      return !!(this.result?.crust?.length && this.result?.crust[0]?.sizes?.length )
    },
    getPlaceHolderImg(){
      const img =  this.$store.getters[keyMapsGetter.GET_PLACE_HOLDER_IMAGE]?.square;
      const fallBack = staticImgBaseUrl + '/images/global/default-product-img-lg.png'
      return img || fallBack;
    },
    getBogoConfig() {
      return this.$store.getters[keyMapsGetter.GET_BOGO_CONFIG];
    },
    isItemBogo() {
      const { applicableProductsIds = "" } = this.getBogoConfig;
      return applicableProductsIds.split(",")
        .map(Number)
        .includes(this.result.id);
    },
    bogoItemTag() {
      const { tag = [] } = this.getBogoConfig;
      const { items = [] } = tag.length ? tag[0] : {};
      let bogoTag = "";
      for(const item of items) {
        const {
          products = [],
          label = []
        } = item;
        if(products.map(Number).includes(this.result.id)) {
          bogoTag = label[0];
        }
      }
      return bogoTag;
    },
    currentStoreDetails() {
      return this.$store?.state?.Location?.storeDetails || {};
    },
  },
}; 
</script>

